<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate">添加</el-button>
    </div>
    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column align="center" type="index" label="序号" width="95" />
      <el-table-column label="图片" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.cover_url" style="height:80px" />
        </template>
      </el-table-column>
      <el-table-column label="跳转类型" min-width="110" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.link_type === 1">活动</template>
          <template v-if="scope.row.link_type === 2">测评体验</template>
          <template v-if="scope.row.link_type === 3">公众号文章</template>
          <template v-if="scope.row.link_type === 4">平台内文</template>
          <template v-if="scope.row.link_type === 5">无跳转</template>
        </template>
      </el-table-column>

      <el-table-column align="center" label="点击次数" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.click_number }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="点击人数" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.click_number_people }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="状态" min-width="110">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state" type="success">正常</el-tag>
          <el-tag v-else type="danger">已下架</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="created_at" label="创建时间" min-width="140">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDel(scope.row.id)">删除</el-button>

          <el-button v-if="scope.row.state === 0" type="primary" size="mini"
            @click="switchState('上架', scope.row.id)">上架</el-button>

          <el-button v-else type="warning" size="mini" @click="switchState('下架', scope.row.id)">下架</el-button>

        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      width="700px">
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="150px">
        <el-form-item label="图片(414*440倍数)" prop="cover_url">
          <upload-one v-model="form.cover_url" width="100%" height="250px"></upload-one>
        </el-form-item>
        <el-form-item label="跳转类型" prop="link_type">
          <el-select v-model="form.link_type" @change="getNavigationType">
            <el-option label="活动" :value="1" />
            <el-option label="测评体验" :value="2" />
            <el-option label="公众号文章" :value="3" />
            <el-option label="平台内文章" :value="4" />
            <el-option label="无跳转" :value="5" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="form.link_type === 1" label="活动" prop="link_to">
          <el-select v-loading="activityLoading" v-model="form.link_to" filterable>
            <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.title"
              :value="Number(type.id)" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="form.link_type === 2" label="测评体验" prop="link_to">
          <el-select v-loading="activityLoading" v-model="form.link_to" filterable>
            <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.name" :value="type.id" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="form.link_type === 3" label="跳转链接" prop="link_to">
          <el-input v-model="form.link_to" />
        </el-form-item>

        <el-form-item v-if="form.link_type === 4" label="平台文章" prop="link_to">
          <el-select v-loading="activityLoading" v-model="form.link_to" filterable>
            <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.title" :value="type.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="权重" prop="weight">
          <el-input-number v-model.number="form.weight" :min="1" :max="9999"></el-input-number>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" :rows="4" v-model="form.description" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import { banner } from "@/api/operation";
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";

export default {
  components: {
    "img-crop-upload": imgCropUpload,
    uploadList,
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      activityList: {},
      listQuery: {
        page: 1,
        limit: 10,
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加",
      },
      dialogPvVisible: false,
      pvData: [],
      form: {
        id: "",
        category_id: 1,
        cover_url: null,
        link_type: null,
        link_to: "",
        weight: 0,
        description: "",
      },
      rules: {
        cover_url: [
          { required: true, message: "图片不能为空", trigger: "blur" },
        ],
        link_type: [
          { required: true, message: "请选择跳转类型", trigger: "blur" },
        ],
        link_to: [
          { required: true, message: "请输入跳转路径", trigger: "blur" },
        ],
        weight: [
          {
            type: "number",
            required: true,
            message: "请输入权重",
            trigger: "blur",
          },
        ],
        description: [
          { required: false, message: "请输入描述文字", trigger: "blur" },
        ],
      },
      btnLoading: false,
      activityLoading: false,
      show: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/banners?category_id=1", // category_id:{1.首页轮播图}
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    async getNavigationType(link_type, noClear = false) {
      if (!noClear) this.form.link_to = "";
      if (link_type === 3 || link_type === 5) return;

      this.activityLoading = true;

      const { data } = await banner.navigationType(link_type);
      this.activityList = data;

      this.activityLoading = false;
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        category_id: 1,
        cover_url: null,
        link_type: null,
        link_to: "",
        weight: 0,
        description: "",
      };
      this.btnLoading = false;
    },

    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    async handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      this.form.link_to = Number(row.link_to);
      await this.getNavigationType(this.form.link_type, true);
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          banner
            .createBanner(this.form)
            .then(() => {
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
              this.getList();
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleDel(val) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/banners/delete",
            method: "post",
            params: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    toggleShow() {
      this.show = !this.show;
    },
    switchState(text, id) {
      this.$confirm("此操作将" + text + "该banner, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        banner.state({id})
          .then(() => {
            this.$message({
              message: "操作成功!",
              type: "success"
            });
            this.getList();
          })
          .catch(() => {
            this.$message.error("操作失败!");
          });
      });
    },
  },
};
</script>

<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.uploaded-img {
  width: 120px;
  height: 120px;
}

.upload-block:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.upload-one-component .upload-one-component-image {
  width: auto;
  height: 200px;
}
</style>
